import { MessageBox, Loading } from 'element-ui';
import { Manage_internet_service } from "../services/Manage_internet_service"
import moment from "moment"
const { Parser } = require('json2csv');

const state = {
    user_id : null,
    provider_id : "",
    provider_type : null,
    provider_type_th : null,
    provider_name : null,
    file_path : null,
    file_type : null,
    lists : [],
    details : null,
    prepares :[],
    errors : [],
    missings : [],
    recent : null,
    monthly : null,
    formdata : null,
    histories : null,
    name : null,
    forward_path : null,
    total : 0,
    schema : {
        promotion_code:         "รหัสรายการส่งเสริมการขาย",
        promotion_name_th:      "ชื่อรายการส่งเสริมการขาย (ภาษาไทย)" ,
        promotion_name_en:      "ชื่อรายการส่งเสริมการขาย (ภาษาอังกฤษ)" ,
        promotion_technology:   "ประเภทเทคโนโลยีของการให้บริการ" ,
        promotion_type:         "ชนิดของรายการส่งเสริมการขาย" ,
        start_sale_date:        "วันเริ่มต้นของการเสนอขาย" ,
        end_sale_date:          "วันสิ้นสุดของการเสนอขาย" ,
        start_service_date:     "วันเริ่มต้นของการให้บริการ" ,
        end_service_date:       "วันสิ้นสุดของการให้บริการ" ,
        promotion_price:        "ค่าบริการเหมาจ่ายรวมตามสิทธิการให้บริการ" ,
        download_speed:         "ความเร็วดาวน์โหลด" ,
        upload_speed:           "ความเร็วอัปโหลด" ,
        content_service_th:     "บริการความบันเทิง Contents (ภาษาไทย)" ,
        content_service_en:     "บริการความบันเทง Contents (ภาษาอังกฤษ)" ,
        mobile_service_th:      "บริการโทรศัพท์เคลื่อนที่ (ภาษาไทย)" ,
        mobile_service_en:      "บริการโทรศัพท์เคลื่อนที่ (ภาษาอังกฤษ)" ,
        wifi_service_th:        "บริการ WiFi/Hotspot (ภาษาไทย)" ,
        wifi_service_en:        "บริการ WiFi/Hotspot (ภาษาอังกฤษ)" ,
        fixed_line_service_th:  "บริการ Fixed Line (ภาษาไทย)" ,
        fixed_line_service_en:  "บริการ Fixed Line (ภาษาอังกฤษ)" ,
        device_service_th:       "บริการอุปกรณ์อื่นๆ (ภาษาไทย)",
        device_service_en:       "บริการอุปกรณ์อื่นๆ (ภาษาอังกฤษ)",
        other_service_th:       "การให้บริการอื่นๆ (ภาษาไทย)" ,
        other_service_en:       "การให้บริการอื่นๆ (ภาษาอังกฤษ)" ,
        privilege_content_th:   "บริการความบันเทิง Contents (ภาษาไทย)",
        privilege_content_en:   "บริการความบันเทง Contents (ภาษาอังกฤษ)",
        privilege_mobile_th:    "บริการโทรศัพท์เคลื่อนที่ (ภาษาไทย)",
        privilege_mobile_en:    "บริการโทรศัพท์เคลื่อนที่ (ภาษาอังกฤษ)",
        privilege_wifi_th:      "บริการ wiFi/Hotspot (ภาษาไทย)",
        privilege_wifi_en:      "บริการ wiFi/Hotspot (ภาษาอังกฤษ)",
        privilege_premium_th:   "พรีเมี่ยม (ภาษาไทย)",
        privilege_premium_en:   "พรีเมี่ยม (ภาษาอังกฤษ)",
        privilege_device_th:    "อุปกรณ์อื่นๆ (ภาษาไทย)",
        privilege_device_en:    "อุปกรณ์อื่นๆ (ภาษาอังกฤษ)",
        privilege_other_th:     "การให้บริการอื่นๆ (ภาษาไทย)",
        privilege_other_en:     "การให้บริการอื่นๆ (ภาษาอังกฤษ)",
        internet_per_Mbps:      "อัตราค่าบริการต่อหน่วย (บาท/Mbps)",
        promotion_condition_th: "ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาไทย)" ,
        promotion_condition_en: "ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาอังกฤษ)" ,
        promotion_link_url:     "ลิงก์เว็บไซต์หรือลิงก์รายการส่งเสริมการขาย" ,
        promotion_banner:       "ลิงก์รูปโฆษณาหรือรายการส่งเสริมการขาย" ,
    },
    loading : true,
    download_form : null,
    download_data : null,
    fields: [{
        label: 'รหัสรายการส่งเสริมการขาย',
        value: 'promotion_code'
      }, {
        label: 'ชื่อรายการส่งเสริมการขาย',
        value: 'promotion_name_th'
      }, {
        label: 'ประเภทเทคโนโลยีของการให้บริการ',
        value: 'promotion_technology'
      }, {
        label: 'ชนิดของรายการส่งเสริมการขาย',
        value: 'promotion_type'
      }, {
        label: 'วันเริ่มต้นของการเสนอขาย',
        value: 'start_sale_date'
      }, {
        label: 'วันสิ้นสุดของการเสนอขาย',
        value: 'end_sale_date'
      }, {
        label: 'ค่าบริการเหมาจ่ายรวมตามสิทธิการใช้งาน',
        value: 'promotion_price'
      }, {
        label: 'ความเร็วดาวน์โหลด Mbps',
        value: 'download_speed'
      }, {
        label: 'ความเร็วอัปโหลด Mbps',
        value: 'upload_speed'
      }, {
        label: 'บริการ Internet (บาท/Mbps)',
        value: 'internet_per_Mbps'
      }, {
        label: 'เงื่อนไขอื่นๆ / ข้อกำหนด ของการใช้บริการ',
        value: 'promotion_condition_th'
      }, {
        label: 'บริการความบันเทิง',
        value: 'privilege_content_th'
      }, {
        label: 'บริการโทรศัพท์เคลื่อนที่',
        value: 'privilege_mobile_th'
      }, {
        label: 'บริการ WiFi/Hotspot',
        value: 'privilege_wifi_th'
      }, {
        label: 'บริการพรีเมียม',
        value: 'privilege_premium_th'
      }, {
        label: 'อุปกรณ์อื่นๆ',
        value: 'privilege_device_th'
      }, {
        label: 'การให้บริการอื่นๆ',
        value: 'privilege_other_th'
      }, {
        label: 'ลิงก์เว็บไซต์หรือลิงก์รายการส่งเสริมการขายของผู้ให้บริการ',
        value: 'promotion_link_url'
      }]
};
const actions = {

    async searchPopularPromotion({commit,state}, formInfo){
      let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
      commit('SET_FORM_DOWNLOAD',formInfo)
      if(formInfo.year != '' && formInfo.quarter != ''){
        let start = moment(formInfo.year).add((formInfo.quarter-1)*3, 'M').format('YYYY-MM-DD');
        let end = moment(start).add(3, 'M');
        end = moment(end).subtract(1, 'd').format('YYYY-MM-DD');
        formInfo.dateRange[0] = start;
        formInfo.dateRange[1] = end;
      } else {
        let quarter = moment(formInfo.dateRange[0]).quarter()
        let year = moment(formInfo.dateRange[0]).year()
        let start = moment(year + '-01-01').add((quarter-1)*3, 'M').format('YYYY-MM-DD');
        let end = moment(start).add(3, 'M');
        end = moment(end).subtract(1, 'd').format('YYYY-MM-DD');
        formInfo.dateRange[0] = start;
        formInfo.dateRange[1] = end;
      }
      let result = await Manage_internet_service.searchPopularPromotion(formInfo)
      if(result.status === 200){
        result.recent = state.recent ? state.recent : await Manage_internet_service.getRecentMissingRow(formInfo)
        commit('RECENT_ROW',result.recent)
        commit('FETCH_TABLE',result)
        setTimeout(function(){ loadingInstance.close() }, 250);
      } else {
        setTimeout(function(){ loadingInstance.close() }, 250);
        MessageBox.confirm(result.message, 'แจ้งเตือน', {
          confirmButtonText: 'ตกลง',
          showCancelButton: false,
          type: 'warning'
        })
      }
    },

    async downloadPopularPromotion({commit}, formInfo){
        if(formInfo.year != '' && formInfo.quarter != ''){
            let start = moment(formInfo.year).add((formInfo.quarter-1)*3, 'M').format('YYYY-MM-DD');
            let end = moment(start).add(3, 'M');
            end = moment(end).subtract(1, 'd').format('YYYY-MM-DD');
            formInfo.dateRange[0] = start;
            formInfo.dateRange[1] = end;
        } else {
            let quarter = moment(formInfo.dateRange[0]).quarter()
            let year = moment(formInfo.dateRange[0]).year()
            let start = moment(year + '-01-01').add((quarter-1)*3, 'M').format('YYYY-MM-DD');
            let end = moment(start).add(3, 'M');
            end = moment(end).subtract(1, 'd').format('YYYY-MM-DD');
            formInfo.dateRange[0] = start;
            formInfo.dateRange[1] = end;
        }
        formInfo.download = true
        let result = await Manage_internet_service.searchPopularPromotion(formInfo)
        if(result.status === 200){
            commit('SET_DOWNLOAD_DATA', result)
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

};

const mutations = {
    SET_PROVIDER_ID(state,id){
        state.provider_id = id
    },
    SET_PROVIDER_TYPE(state,type){
        state.provider_type = type
    },
    SET_PROVIDER_NAME(state,name){
        state.provider_name = name
    },
    SET_USER_ID(state,id){
        state.user_id = id
    },
    SET_FORM_DOWNLOAD(state, form){
        state.download_form = JSON.parse(JSON.stringify(form))
    },
    FETCH_TABLE(state,obj){
        let promotion = obj.data.result
        let recent = obj.recent.data
            recent = recent.filter(item => item.diff > -5)
            recent = recent.map(item => item = item.promotion_code)
        state.lists = []
        let today = moment()
        promotion.forEach(function(val){
            val.disabled = (moment(val.end_service_date).diff(today,'days') < 0)
            if(recent.includes(val.promotion_code)){ 
                val.disabled = false
            }
            val.created_at = moment(val.created_at).add(543, 'y').format('DD/MM/YYYY') != 'Invalid date' ? moment(val.created_at).add(543, 'y').format('DD/MM/YYYY') : ''
            val.start_sale_date = moment(val.start_sale_date).add(543, 'y').format('DD/MM/YYYY') != 'Invalid date' ? moment(val.start_sale_date).add(543, 'y').format('DD/MM/YYYY') : ''
            val.end_sale_date = moment(val.end_sale_date).add(543, 'y').format('DD/MM/YYYY') != 'Invalid date' ? moment(val.end_sale_date).add(543, 'y').format('DD/MM/YYYY') : ''
            val.start_service_date = moment(val.start_service_date).add(543, 'y').format('DD/MM/YYYY') != 'Invalid date' ? moment(val.start_service_date).add(543, 'y').format('DD/MM/YYYY') : ''
            val.end_service_date = moment(val.end_service_date).add(543, 'y').format('DD/MM/YYYY') != 'Invalid date' ? moment(val.end_service_date).add(543, 'y').format('DD/MM/YYYY') : ''
        })
        state.lists = promotion
        state.total = promotion.length > 0 ? promotion[0].total : 0
    },
    SET_DOWNLOAD_DATA(state,obj){
        let promotion = obj.data.result
        promotion.forEach(function(val){
            val.created_at = moment(val.created_at).add(543, 'y').format('DD/MM/YYYY') != 'Invalid date' ? moment(val.created_at).add(543, 'y').format('DD/MM/YYYY') : ''
            val.start_sale_date = moment(val.start_sale_date).add(543, 'y').format('DD/MM/YYYY') != 'Invalid date' ? moment(val.start_sale_date).add(543, 'y').format('DD/MM/YYYY') : ''
            val.end_sale_date = moment(val.end_sale_date).add(543, 'y').format('DD/MM/YYYY') != 'Invalid date' ? moment(val.end_sale_date).add(543, 'y').format('DD/MM/YYYY') : ''
            val.start_service_date = moment(val.start_service_date).add(543, 'y').format('DD/MM/YYYY') != 'Invalid date' ? moment(val.start_service_date).add(543, 'y').format('DD/MM/YYYY') : ''
            val.end_service_date = moment(val.end_service_date).add(543, 'y').format('DD/MM/YYYY') != 'Invalid date' ? moment(val.end_service_date).add(543, 'y').format('DD/MM/YYYY') : ''
        })
        state.download_data = promotion
        let fields = state.fields
        CsvExport(state.download_data, fields, 'Popular_pro_internet')
    },
    COUNTING(state,num){
        state.total = null
        state.total = num
    },
    RECENT_ROW(state, obj){
        state.recent = obj
    }
};

let CsvExport = function(data, fields, fileName) {
  try {
    const parser = new Parser({fields});
    // console.log(json2csv.parse(data, {fields}))
    const result = parser.parse(data);
    // var csvContent = 'data:text/csvcharset=GBK,\uFEFF' + result
    var csvContent = 'data:application/vnd.ms-excel;csvcharset=GBK,\uFEFF' + encodeURIComponent(result)
    // var encodedUri = encodeURI(csvContent)
    var link = document.createElement('a')
    // link.setAttribute('href', encodedUri)
    link.setAttribute('href', csvContent)
    // link.setAttribute('download', `${(fileName || 'file')}.csv`)
    link.setAttribute('download', `${(fileName || 'file')}.xls`)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } catch (err) {
    console.error(err)
  }
}

export const Report_popular_internet = {
    namespaced: true,
    state,
    actions,
    mutations
};
